import React, { Component } from "react";
import axios from "axios";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import {
  Container,
  Paper,
  Grid,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Radio,
  RadioGroup,
  FormControlLabel
} from "@mui/material";
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';



import EditIcon from '@mui/icons-material/EditSquare';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

import SearchIcon from '@mui/icons-material/Search';
import Autocomplete from "@mui/material/Autocomplete";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Serverurl from "./Apiurl";
export default class Transactions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fromDate: dayjs().startOf("month"),
      toDate: dayjs(),
      projectId: "",
      vendorId: "",
      vendorType: "1",
	  status: "",
	  
      selectedProject: null,
      selectedVendor: null,
	  openEdit: false,
selectedVendorEdit: null,
selectedProjectEdit: null,
      projectarrauto: [],
      vendorarrauto: [],
      reportData: [],
      ts_id: 0,
      ts_pj_id: "",
      ts_vm_id: "",
      ts_date: dayjs(),
      ts_amount: "",
      ts_mode: "",
	  ts_status:"",
      ts_remarks: "",
	  
	modearrauto: [],
selectedMode: null,
ts_mode: "",
ts_id: 0,
selectedProjectInsert: null,
selectedProjectEdit: null,
openInsert: false,
ts_pj_id: "",
ts_vm_id: "",
ts_date: dayjs(),
ts_amount: "",
ts_mode: "",
ts_remarks: "",
ts_bill: "",
selectedProjectInsert: null,
selectedVendorInsert: null,
insertVendorType: "1",
      page: 0,
      rowsPerPage: 50,
      totalRecords: 0,
      userid: localStorage.getItem("userid") || 1
    };
  }
  modeMap = {
  1: "Cash",
  2: "Bank Transfer",
  3: "UPI",
  4: "Cheque"
};
modeOptions = [
  { id: "", label: "All" },
  { id: 1, label: "Cash" },
  { id: 2, label: "Bank Transfer" },
  { id: 3, label: "UPI" },
  { id: 4, label: "Cheque" }
];
  componentDidMount() {
	  
	    document.title = "VR Builders - Payments";
        
   	if(localStorage.getItem("VRuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Userlogin'
          })
		  }
let strname="Vendor Payments";   
			 this.props.parentsCallback(
           strname
        );
    this.fetchReport();
  }
  /* ---------------- PROJECT ---------------- */
onloadProjectBind = (event) => {
  const value = event.target.value;
  axios
    .get(
      Serverurl +
        "ajaxprojects.php?action=getallprojectautoextender&projectname=" +
        value
    )
    .then((res) => {
      this.setState({
        projectarrauto: (res.data || []).map((r) => ({
          title: r.pj_projectname,
          pj_id: r.pj_id
        }))
      });
    })
    .catch(() => {
      this.setState({ projectarrauto: [] });
    });
};
  /* ---------------- VENDOR TYPE ---------------- */
  onVendorTypeChange = (e) => {
    this.setState({
      vendorType: e.target.value,
      vendorId: "",
      selectedVendor: null,
      vendorarrauto: []
    });
  };
  /* ---------------- VENDOR ---------------- */
onloadVendorBind = (event) => {
  const value = event.target.value;
  axios
    .get(
      Serverurl +
        "ajaxtransactions.php?action=vendortypeautoextender" +
        "&vm_vendorname=" +
        value +
        "&vm_type=" +
        this.state.insertVendorType
    )
    .then((res) => {
      this.setState({
        vendorarrauto: (res.data || []).map((r) => ({
          title: r.vm_vendorname,
          vm_id: r.vm_id
        }))
      });
    });
};
  //modeofpayment
onloadModeBind = (event) => {
  const value = event.target.value;
  axios
    .get(
      Serverurl +
        "ajaxtransactions.php?action=transactionmodeautoextender&mode_text=" +
        value
    )
    .then((res) => {
      const data =
        Array.isArray(res.data)
          ? res.data
          : Array.isArray(res.data?.data)
          ? res.data.data
          : [];
      this.setState({
        modearrauto: data.map((r) => ({
          title: r.mode_name,
          id: r.ts_mode
        }))
      });
    });
};
 fetchReport = () => {
  axios
    .get(
      Serverurl +
        "ajaxtransactions.php?action=getall" +
        "&ts_pj_id=" +
        this.state.projectId +
        "&ts_vm_id=" +
        this.state.vendorId +
        "&ts_mode=" +
        this.state.ts_mode +
        "&ts_status=" +
		this.state.status +
        "&fromdate=" +
        this.state.fromDate.format("YYYY-MM-DD") +
        "&todate=" +
        this.state.toDate.format("YYYY-MM-DD") +
        "&StartIndex=" +
        this.state.page +
        "&PageSize=" +
        this.state.rowsPerPage +
        "&sorting=ts_id desc"
    )
    .then((res) => {
		console.log(res.data);
      this.setState({
        reportData: res.data || [],
        totalRecords: res.data?.[0]?.count || 0
      });
    });
};

onInsertVendorTypeChange = (e) => {
  this.setState({
    insertVendorType: e.target.value,
    ts_vm_id: "",
    selectedVendorInsert: null,
    vendorarrauto: []
  });
};
   render() {
    return (
      <React.Fragment>

  

   

       <div className="searchmaster">
            <ul>
                                <li>
        <p>From Date</p>
        <p><LocalizationProvider dateAdapter={AdapterDayjs}> <DatePicker
		disableFuture className="inputcntlparent"
		format="DD/MM/YYYY"
          value={this.state.fromDate}
          onChange={(v) => this.setState({ fromDate: v })}
        />
</LocalizationProvider></p>   </li>

        <li>
        <p>To Date</p>
       <p><LocalizationProvider dateAdapter={AdapterDayjs}>  <DatePicker
		disableFuture className="inputcntlparent"
		format="DD/MM/YYYY"
          value={this.state.toDate}
          onChange={(v) => this.setState({ toDate: v })}
        />
</LocalizationProvider></p>   </li>


		<li>
		<p>Status</p>
		<p>
			<FormControl  className="stadrp">			   
			<Select
			  className="inputcntlparent"
			  size="small"
			  variant="outlined"
			  native
			  value={this.state.status}
			  onChange={(e) => this.setState({ status: e.target.value })}
			  name="status"
			  id="status"
			>
			  <option value="">Select</option>
			  <option value="1">Yet to be Claimed</option>
			  <option value="2">Already Claimed</option>
			</Select>
			</FormControl>
		</p>
		
		</li>


           <li>
        <p>Project</p>
        <p> <Autocomplete className="inputcntlparent"
          options={this.state.projectarrauto}
          value={this.state.selectedProject}
          onChange={(e, v) =>
            this.setState({
              selectedProject: v,
              projectId: v?.pj_id || ""
            })
          }
          getOptionLabel={(o) => o.title || ""}
          renderInput={(params) => (
            <TextField
              {...params} size="small"
              onChange={this.onloadProjectBind}
            />
          )}
        /> </p> </li>
 

        <li>
       <p>Vendor Type</p>
          <p> <RadioGroup
          row
          value={this.state.vendorType}
          onChange={this.onVendorTypeChange}
        >
          <FormControlLabel value="1" control={<Radio />} label="Mastri" />
          <FormControlLabel value="2" control={<Radio />} label="Vendor" />
          <FormControlLabel value="3" control={<Radio />} label="Service" />
        </RadioGroup></p></li>


       <li>
        <p>Vendor</p>
        <p> <Autocomplete className="inputcntlparent"
          options={this.state.vendorarrauto}
          value={this.state.selectedVendor}
          onChange={(e, v) =>
            this.setState({
              selectedVendor: v,
              vendorId: v?.vm_id || ""
            })
          }
          getOptionLabel={(o) => o.title || ""}
          renderInput={(params) => (
            <TextField
              {...params} size="small"
              onChange={this.onloadVendorBind}
            />
          )}
        /></p>
      </li>

       <li> <p>&nbsp;</p>
         <p><Button variant="contained"   className="exportbtn" onClick={this.fetchReport} endIcon={<SearchIcon />}>
          Search
        </Button></p>
     </li>

     </ul>

    </div>




          {/* TABLE */}
          <TableContainer sx={{ mt: 3 }}>
            <Table>
              <TableHead>
                <TableRow >
                  <TableCell >Project</TableCell>
                  <TableCell >Vendor</TableCell>
                  <TableCell >Date</TableCell>
                  <TableCell >Mode</TableCell>
				      <TableCell >Type</TableCell>
				  <TableCell >Amount</TableCell>
				  		  <TableCell >Bill</TableCell>
                  <TableCell ></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {this.state.reportData.map((r, i) => (
                  <TableRow key={i}>
                    <TableCell>{r.pj_projectname}</TableCell>
                    <TableCell>{r.vm_vendorname}</TableCell>
                    <TableCell>
  {r.ts_date ? dayjs(r.ts_date).format("DD-MM-YYYY") : ""}
</TableCell>
<TableCell>
  {r.ts_modename}
</TableCell>
<TableCell>{r.vm_typename}

</TableCell>
<TableCell>
 Rs. {parseFloat(r.ts_amount ).toFixed(2)}
</TableCell>
<TableCell>
{r.ts_bill!=="" && (
<a href={Serverurl+"uploads/"+r.ts_bill} target="_blank"><FileDownloadIcon /></a>

)}


</TableCell>

                    <TableCell>
					
					{r.pj_isactive==="0" && (
                      <Link to={`/Paymenttransactions?ts_id=${r.ts_id}`}>
  <Button variant="contained" className="editbtn"  endIcon={<EditIcon />}>
					
</Button>
					</Link>)}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <TablePagination
			 rowsPerPageOptions={[50, 100, 150, 200, 250]}  
              component="div"
              count={this.state.totalRecords}
              page={this.state.page}
              onPageChange={(e, p) => this.setState({ page: p }, this.fetchReport)}
              rowsPerPage={this.state.rowsPerPage}
              onRowsPerPageChange={(e) =>
                this.setState(
                  { rowsPerPage: parseInt(e.target.value, 10), page: 0 },
                  this.fetchReport
                )
              }
            />
          </TableContainer>
      
      </React.Fragment>
    );
  }
}
